module.exports = __webpack_public_path__ + "static/media/left-white.4acb15ae.svg";